import { styled } from 'baseui';
import { Button } from 'baseui/button';

export const DashboardContainer = styled('div', {
  width: '100%',
  overflowX: 'auto',
});

export const TournamentActionButton = styled(Button, {
  marginLeft: '8px',
});

export const DashboardHeaderContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
});

export const DashboardTitleContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const DashboardHeading = styled('h1', {
  margin: 0,
  padding: 0,
});

export const DashboardParagraph = styled('p', {
  margin: 0,
  padding: 0,
});

export const DashboardActionsContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  justifyContent: 'space-between',
});

export const ErrorParagraph = styled('p', {
  color: 'red',
});

export const ButtonGroup = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
});

export const DashboardContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

export const DeleteButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      color: $theme.colors.negative,
      height: '36px',
      minWidth: '52px',
    }),
  },
};
